export default "__VITE_ASSET__DzHanpY2__"